<script lang="ts" setup>
import  { type PropType } from 'vue'

import { type Product } from '@/types'

import { useProductRecommendations } from '@/composables'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true    
  },
})

const { 
  productRecommendations
} = useProductRecommendations(props.product)
</script>

<template>
  <!-- Start Related Products -->
  <section
    v-if="productRecommendations.length > 0"
    aria-labelledby="related-heading" 
    class="py-8 border-gray-200 lg:border-t sm:px-0 pl-8"
  >
    <div class="flex items-center justify-between pr-5">
      <h2 
        id="related-heading" 
        class="text-white text-sm sm:text-base uppercase font-bold tracking-widest"
      >
        You May Also Like
      </h2>
    </div>

    <!-- Start Products New In Carousel Scroller -->
    <ProductsCarouselScroller 
      :products="productRecommendations"
    />
    <!-- End Products New In Carousel Scroller -->
  </section>
  <!-- End Related Products -->
</template>